type DashboardTableQueryKeyFilters = {
  page?: number
  limit?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  fromDate?: string
  toDate?: string
  dateField?: string
  timezone?: string
  noVisitDate?: boolean
  severity?: number
  clinicianEmail?: string
  patientMrn?: string
  location?: string
  program?: string
  measureIds?: string[]
}

export const queryKeys = {
  all: ['queries'] as const,
  dashboardFilterOptions: (directoryId: string) => [
    ...queryKeys.all,
    'dashboardFilterOptions',
    directoryId,
  ],
  dashboardGraph: (directoryId: string, filters: string[]) => [
    ...queryKeys.all,
    'dashboardGraph',
    directoryId,
    ...filters,
  ],
  dashboardGraphEvents: (directoryId: string, filters: string[]) => [
    ...queryKeys.all,
    'dashboardGraphEvents',
    directoryId,
    ...filters,
  ],
  dashboardTableClinicians: (directoryId: string, filters: DashboardTableQueryKeyFilters) => [
    ...queryKeys.all,
    'dashboardTableClinicians',
    directoryId,
    filters,
  ],
  dashboardTablePatients: (directoryId: string, filters: DashboardTableQueryKeyFilters) => [
    ...queryKeys.all,
    'dashboardTablePatients',
    directoryId,
    filters,
  ],
  dashboardTableDocuments: (directoryId: string, filters: DashboardTableQueryKeyFilters) => [
    ...queryKeys.all,
    'dashboardTableDocuments',
    directoryId,
    filters,
  ],
  dashboardTableMeasures: (directoryId: string, filters: DashboardTableQueryKeyFilters) => [
    ...queryKeys.all,
    'dashboardTableMeasures',
    directoryId,
    filters,
  ],
  dashboardNoDateOfServiceCount: (directoryId: string, filters: string[]) => [
    ...queryKeys.all,
    'dashboardNoDateOfServiceCount',
    directoryId,
    ...filters,
  ],
  dashboardDetail: (documentId: string) => [...queryKeys.all, 'dashboardDetail', documentId],
  auditHistory: (auditId: string) => [...queryKeys.all, 'auditHistory', auditId],
}
